import {useMediaQuery} from '@mui/material'
import {useDispatch} from 'react-redux'
import {
  useVirtualGiftsRandomGifts,
  virtualGiftsOpenModal,
  virtualGiftsSelectVirtualGift,
  VirtualGiftType
} from 'entities/messages'
import {mediaVariants} from 'shared/lib'
import {Button} from 'shared/ui/buttons'
import {GoCoin20, PlusLarge} from 'shared/ui/icons'
import {Tooltip} from 'shared/ui/tooltip'
import styles from './styles.module.scss'

export const ChatVirtualGifts = () => {
  const dispatch = useDispatch()
  const {desktop, mobile} = useVirtualGiftsRandomGifts()
  const is600p = useMediaQuery('(max-width: 600px)')
  const is768p = useMediaQuery(`(max-width: ${styles.is768p})`)

  const selectVirtualGift = (virtualGift: VirtualGiftType) => {
    dispatch(virtualGiftsSelectVirtualGift(virtualGift))
    dispatch(virtualGiftsOpenModal())
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.virtualGifts}>
        {(is600p ? mobile : desktop).map((item, index) => <div
          key={index}
          className={styles.gift}
          onClick={() => is768p && selectVirtualGift(item)}
        >
          <img src={item.data.url + mediaVariants.square128} alt={item.name} />
          <div className={styles.cost}>{item.price} <GoCoin20 /></div>
          <Button
            styleType='primary'
            className={styles.send}
            onClick={() => selectVirtualGift(item)}
          >
            Send
          </Button>
        </div>)}
      </div>
      <Tooltip title={<div className={styles.tooltipHeader}>More gifts</div>} placement='top'>
        <div className={styles.moreVirtualGifts} onClick={() => dispatch(virtualGiftsOpenModal())}>
          <PlusLarge />
        </div>
      </Tooltip>
    </div>
  )
}